import { Box, Skeleton, Typography, styled } from "@mui/material";
import { FC } from "react";

const MovieCardSkeleton: FC = () => {
  return (
    <CardWrapper>
      <PictureSkeleton variant="rectangular" width="100%" height={0} />
      <Typography variant="h1" component="div">
        <Skeleton />
      </Typography>
    </CardWrapper>
  );
};

export default MovieCardSkeleton;

const CardWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  border: `1px solid ${theme.palette.backgroundAlpha.main}`,
  borderRadius: 6,
  padding: theme.spacing(1.5),
}));
const PictureSkeleton = styled(Skeleton)(({ theme }) => ({
  paddingBottom: `${(192 / 143) * 100}%`,
}));
